
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import {
  addSmsAccountBalance,
  getSmsAccountBalance
} from '@/api/product/smsManage'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'smsBalance',
  components: {}
})
export default class extends Vue {
  @Prop() info!: any

  get language() {
    return AppModule.language
  }

  private flag: boolean = false

  private infoForm: any = {
    balance: '',
    in_or_out: '',
    remark: ''
  }
  private listLoading: boolean = false
  private list: any = []
  private total = 0

  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  private back() {
    this.$emit('close', false)
  }

  private openAddbalance: boolean = false
  // 添加余额
  private openAddBalance() {
    this.openAddbalance = true
  }
  private closeAddAccount() {
    this.openAddbalance = false
    this.getBalanceList()
    this.infoForm = {
      balance: '',
      in_or_out: '',
      remark: ''
    }
  }

  private create() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.flag = true
          const data = {
            ...this.infoForm,
            id: this.info.id
          }
          await addSmsAccountBalance(data).then(() => {
            if (this.language === 'en') {
              this.$message({
                message: 'Create successful!',
                type: 'success'
              })
            }
            if (this.language === 'zh_cn') {
              this.$message({
                message: '添加成功!',
                type: 'success'
              })
            }
            if (this.language === 'zh_tw') {
              this.$message({
                message: '添加成功!',
                type: 'success'
              })
            }
            this.closeAddAccount()
            this.flagStr()
          })
        } catch (error) {
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.getBalanceList()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.getBalanceList()
  }

  // 获取余额列表
  private getBalanceList() {
    this.listLoading = true
    getSmsAccountBalance({ id: this.info.id })
      .then((res: any) => {
        this.total = res.count
        this.list = res.results
        this.listLoading = false
      })
      .catch(() => {
        this.listLoading = false
      })
  }

  mounted() {
    this.getBalanceList()
  }
}
